import { Box, Card, CardContent, Typography } from '@mui/material'

type WorkflowMetricsProps = {
  metrics: {
    draft: number
    review: number
    changes_requested: number
    approved: number
    published: number
  }
}

export function WorkflowMetrics({ metrics }: WorkflowMetricsProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'stretch',
        flexWrap: { xs: 'wrap', lg: 'nowrap' },
      }}
    >
      {[
        { label: 'Draft', value: metrics.draft, color: '#b7791f' },
        { label: 'Pending Review', value: metrics.review, color: '#b7791f' },
        { label: 'Changes Requested', value: metrics.changes_requested, color: '#b42318' },
        { label: 'Approved', value: metrics.approved, color: '#198754' },
        { label: 'Published', value: metrics.published, color: '#0f4c81' },
      ].map(metric => (
        <Box
          key={metric.label}
          sx={{
            display: 'flex',
            flex: { xs: '1 1 calc(50% - 8px)', sm: '1 1 180px', lg: '1 1 0' },
            minWidth: { xs: 'calc(50% - 8px)', sm: 160, lg: 0 },
          }}
        >
          <Card variant="outlined" sx={{ borderRadius: 3, width: '100%', height: '100%' }}>
            <CardContent sx={{ minHeight: 96, pb: '12px !important' }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{
                  display: 'block',
                  minHeight: 32,
                  textTransform: 'uppercase',
                  letterSpacing: '0.04em',
                  lineHeight: 1.35,
                }}
              >
                {metric.label}
              </Typography>
              <Typography variant="h4" fontWeight={700} color={metric.color}>
                {metric.value}
              </Typography>
            </CardContent>
          </Card>
        </Box>
      ))}
    </Box>
  )
}
